<template>
	<v-row>
		<PuzzleTimer :chapterNum="chapterIndex" />
		<PuzzleJournal
			@journal-completed="journalCompleted"
			@journal-index="journalIndex"
		/>
		<v-overlay :value="overlay" opacity="0.9" z-index="10">
			<PuzzleModal
				:loadImage="loadImage"
				:allowZoom="true"
				:magZoom="2"
				@overlay-close="overlayClose"
		/></v-overlay>
		<v-container fill-height fluid style="height:90vh;"
			><v-row no-gutters justify="center" align="center">
				<v-col cols="3">
					<v-container fill-height fluid>
						<v-row no-gutters justify="center" align="center">
							<div
								:class="solvePuzzle() == 5 ? 'solved' : null"
								class="hand-writing_h1 answer_key"
							>
								NEBET
							</div>
						</v-row>
					</v-container>
					<div class="polaroid ma-4">
						<draggable
							class="list-group"
							:class="isDragging ? 'glow' : null"
							:list="polaroid"
							:sort="false"
							v-bind="dragOptions"
							@start="isDragging = true"
							@end="isDragging = false"
							group="map"
						>
							<v-card
								elevation="0"
								class="list-group-item"
								v-for="item in polaroid"
								:key="item.id"
								@click="
									overlay = !overlay;
									loadModalImage(item.img + '.jpg');
								"
							>
								<v-img
									width="100"
									height="100"
									:src="require('@/assets/images/' + item.img + '.jpg')"
								/>
							</v-card>
						</draggable>
					</div>
				</v-col>
				<v-col cols="8">
					<v-container fill-height fluid
						><v-row no-gutters justify="center" align="center">
							<v-img class="bg_map"></v-img>
							<div class="bg_map-container">
								<div v-for="(item, index) in map" :key="index" class="map">
									<span class="limit">{{ index + 1 }}</span>
									<div class="bg">
										<draggable
											class="list-group"
											:class="
												isDragging && item.list.length < maxPerZone
													? 'glow'
													: item.list.length < maxPerZone
													? null
													: null
											"
											:list="item.list"
											v-bind="dragOptions"
											@start="isDragging = true"
											@end="isDragging = false"
											sort="false"
											:group="{
												name: 'map',
												pull: true,
												put: item.list.length > maxPerZone - 1 ? false : true,
											}"
										>
											<v-card
												elevation="6"
												class="list-group-item"
												v-for="item in item.list"
												:key="item.id"
												@click="
													overlay = !overlay;
													loadModalImage(item.img + '.jpg');
												"
											>
												<v-img
													style="height:100%;width:100%"
													height="100%"
													cover
													:src="require('@/assets/images/' + item.img + '.jpg')"
												/>
											</v-card>
										</draggable>
									</div>
								</div>
								<div class="room-1"></div>
								<div class="room-2"></div>

								<div class="terrain a"></div>
								<div class="terrain b"></div>
								<div class="terrain c"></div>
								<div class="terrain d"></div>
								<div class="terrain e"></div>
								<div class="terrain f"></div>
								<div class="terrain g"></div>
							</div> </v-row
					></v-container>
				</v-col>

				<v-container fill-height fluid class="text-center playground">
					<v-row no-gutters justify="center" align="center">
						<v-btn
							large
							color="red"
							dark
							elevation="6"
							@click="resetPuzzle()"
							v-html="$t('action.resetPuzzle')"
						></v-btn>
						<v-btn
							large
							color="primary"
							class="ml-6"
							elevation="6"
							@click="checkPuzzle()"
							v-html="$t('action.checkPuzzle')"
						></v-btn></v-row></v-container></v-row
		></v-container>
	</v-row>
</template>
<script>
import puzzleComponents from "../mixins/puzzleComponents";
import PuzzleTimer from "@/components/PuzzleTimer.vue";
import PuzzleJournal from "@/components/PuzzleJournal.vue";
import PuzzleModal from "@/components/PuzzleModal.vue";
import draggable from "vuedraggable";

export default {
	name: "PuzzleD",
	components: {
		PuzzleTimer,
		PuzzleJournal,
		PuzzleModal,
		draggable,
	},
	mixins: [puzzleComponents],
	data() {
		return {
			overlay: false,
			allowZoom: true,
			loadImage: "",
			map: [
				{ list: [], img: "" },
				{ list: [], img: "" },
				{ list: [], img: "" },
				{ list: [], img: "" },
				{ list: [], img: "" },
			],
			polaroid: [
				{ id: 1, img: "map-large-3" },
				{ id: 2, img: "map-large-5" },
				{ id: 3, img: "map-large-2" },
				{ id: 4, img: "map-large-1" },
				{ id: 5, img: "map-large-4" },
			],
			answers: [[4], [1], [5], [2], [3]],
			solveCount: 5,
			maxPerZone: 1,
			itemReset: [],
			isDragging: false,
			solved: false,
		};
	},
	computed: {
		dragOptions() {
			return {
				animation: 200,
				ghostClass: "ghost",
				dragClass: "item-drag",
			};
		},
	},
	mounted() {
		this.itemReset = this.polaroid.slice();
	},
	methods: {
		journalCompleted: function() {
			this.puzzleSovled();
		},
		overlayClose: function() {
			this.overlay = false;
		},
		loadModalImage: function(imcSrc) {
			this.loadImage = imcSrc;
		},
		getAnswerKey(p) {
			return this.journalData[0].quest[0].answer.charAt(p).toUpperCase();
		},
		resetPuzzle() {
			this.polaroid.splice(0, this.polaroid.length, ...this.itemReset);
			this.map.forEach(function(item) {
				item.list = [];
			});
		},
		solvePuzzle() {
			let answersRight = 0;
			let answers = this.answers.slice();
			this.map.forEach(function(item, index) {
				const list = item.list;
				list.forEach(function(item) {
					answers[index].forEach(function(el) {
						console.log(item.id);
						if (item.id == el) {
							answersRight += 1;
						}
					});
				});
			});
			answersRight === this.solveCount
				? ((this.solved = true), this.showCustom(this.$t("d.solved")))
				: "";
			return answersRight;
		},
		checkPuzzle() {
			this.solvePuzzle() === this.solveCount
				? ((this.solved = true), this.showCustom(this.$t("d.solved")))
				: this.showCustom(this.$t("label.oops"));
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../scss/fonts.scss";

.map,
.polaroid {
	& .list-group {
		border: 4px dashed transparent;
	}
	& .list-group-item {
		display: inline-block;
		cursor: move;
	}
}

.bg_map {
	background-image: url("../assets/images/bg-map.png");
	background-repeat: no-repeat;
	background-position: top center;
	background-size: cover;
	width: 100vw;
	height: 60vh;
	max-width: 800px;
	max-height: 600px;
	min-height: 500px;
	text-align: center;
}

.bg_map-container {
	width: 100vw;
	height: 30vh;
	max-height: 300px;
	max-width: 700px;
	position: absolute;
	.terrain {
		display: block;
		position: absolute;
		content: "";
		background-image: url("../assets/images/bg-map-terrain.png");
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
		z-index: 0;
		&.a {
			width: 18rem;
			left: -2rem;
			top: -3rem;
			height: 18rem;
		}
		&.b {
			left: 14rem;
			top: 4rem;
			width: 8rem;
			height: 8rem;
			transform: rotate(20deg) skew(20deg);
		}
		&.c {
			left: 1.5rem;
			top: 13rem;
			width: 13rem;
			height: 8rem;
		}
		&.d {
			left: 21rem;
			top: -3rem;
			width: 17.6rem;
			height: 23rem;
		}
		&.e {
			left: 20.5rem;
			top: -7rem;
			width: 9rem;
			height: 8rem;
		}
		&.f {
			left: 37.2rem;
			top: 1rem;
			width: 8rem;
			height: 13.5rem;
		}
		&.g {
			left: 20.5rem;
			top: 18rem;
			width: 9rem;
			height: 6rem;
		}
	}
}
.map {
	width: 12rem;
	height: 12rem;
	background-color: #3b342d;
	position: absolute;
	display: flex;
	vertical-align: bottom;
	z-index: 1;

	&:nth-child(1) {
		left: 0rem;
		top: 0rem;
		width: 14rem;
		height: 13rem;

		&:after {
			display: block;
			position: absolute;
			content: "";
			top: 4rem;
			left: -2rem;
			width: 2rem;
			height: 3rem;
			background: #111;
			z-index: 0;
		}
	}
	&:nth-child(2) {
		left: 3.5rem;
		top: 14rem;
		width: 9rem;
		height: 6rem;
		&:before {
			display: block;
			position: absolute;
			content: "";
			top: -1rem;
			left: 3.5rem;
			width: 2rem;
			height: 1rem;
			background: #111;
			z-index: 0;
		}
	}
	&:nth-child(3) {
		left: 13.8rem;
		top: 5rem;
		width: 8.4rem;
		height: 6rem;
		background-color: transparent;
		&:before {
			display: block;
			position: absolute;
			content: "";
			top: 1rem;
			left: -0.1rem;
			width: 9rem;
			height: 5rem;
			background: #3b342d;
			transform: rotate(20deg) skew(20deg);
		}
	}
	&:nth-child(4) {
		left: 22.2rem;
		top: -6rem;
		width: 6rem;
		height: 5rem;
		&:before {
			display: block;
			position: absolute;
			content: "";
			top: 5rem;
			left: 2rem;
			width: 2rem;
			height: 1rem;
			background: #111;
			z-index: 0;
		}
	}
	&:nth-child(5) {
		left: 22rem;
		top: 0rem;
		width: 15.6rem;
		height: 17rem;
	}

	& .bg {
		height: 100vh;
		width: 100%;
		background-position: center center;
		background-size: contain;
		background-repeat: no-repeat;
		max-height: 16rem;
		margin-top: -4rem;
	}
	& .list-group {
		text-align: center;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		margin: auto;
		overflow: hidden;
	}
	& .list-group-item {
		border-radius: 0;
		display: inline-block;
		text-align: center;
		text-decoration: none;
		-webkit-transition: all 0.2s linear;
		-moz-transition: all 0.2s linear;
		transition: all 0.2s linear;
		z-index: 0;
		position: relative;
		overflow: auto;
		height: 100%;
		background-color: transparent;
		overflow: hidden;
		& .v-image__image {
			border: 12px solid #fff;
		}
	}
}

.room-1 {
	left: 22.2rem;
	top: 18rem;
	width: 6rem;
	height: 5rem;
	background-color: #3b342d;
	position: absolute;
	z-index: 5;
	&:before {
		display: block;
		position: absolute;
		content: "";
		top: -1rem;
		left: 2rem;
		width: 2rem;
		height: 1rem;
		background: #111;
		z-index: 0;
	}
}

.room-2 {
	left: 39rem;
	top: 4rem;
	width: 5rem;
	height: 9rem;
	background-color: #3b342d;
	position: absolute;
	z-index: 5;
	&:before {
		display: block;
		position: absolute;
		content: "";
		top: 3rem;
		left: -1.5rem;
		width: 1.5rem;
		height: 3rem;
		background: #111;
		z-index: 0;
	}
}

.polaroid {
	& .list-group {
		padding: 1rem 0;
		transition: height 4s;
		//background-image: url("../assets/images/bg-corkboard.jpg");
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center center;
		//border: 4px solid #111;
		text-align: center;
		min-height: 400px;
	}
	& .list-group-item {
		margin: 10px;
		border-radius: 0;
		background: #ffffff;
		display: inline-block;
		padding: 5px 5px 30px;
		text-align: center;
		text-decoration: none;
		-webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
		-moz-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
		box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
		-webkit-transition: all 0.2s linear;
		-moz-transition: all 0.2s linear;
		transition: all 0.2s linear;
		z-index: 0;
		position: relative;
	}
	& .v-image__image {
		display: block;
		width: 250px;
	}
}

.answer_key {
	display: none;
	&.solved {
		z-index: 6;
		display: block;
		top: 4em;
		width: 272px;
		background: #fff;
	}
}

.glow {
	animation: glow 1s ease-in-out infinite alternate;
	border: 0 dashed #fff !important;
}

@keyframes glow {
	from {
		background: #8c9eff;
	}
	to {
		background: $primary;
	}
}

.ghost {
	opacity: 0.4;
}

.limit {
	color: #fff;
	bottom: 0;
	position: absolute;
	padding: 0.25rem;
	margin: 0.5rem;
	font-size: 1rem;
	background: #77736f;
	width: 2rem;
	text-align: center;
	border-radius: 50%;
	z-index: 5;
}

::v-deep {
	.map .v-responsive__sizer {
		height: 100%;
		overflow: hidden;
	}
	&.bg_map-container .list-group-item {
		& .v-image__image {
			border: 12px solid #fff;
		}
	}
}
</style>
